module.exports = __webpack_public_path__ + "img/1.032909f0.png";